import square from '../elements/square.js';
square.register();
